<template>
  <div class="index_box" ref="index_box">
   1
    <!-- <tab-bar :current-index="1"></tab-bar> -->
      <!-- <div class="index_exam_list_box">
        <div class="index_exam_list_tit">今日推荐</div>
        <ul>
          <li v-for="(item, index) in examDate" :key="index" @click="gotoexamlink(item.id)">{{item.title}}</li>
        </ul>
      </div> -->
      <!-- <div class="index_year_box" v-for="(year, index) in listData" :key="index">
        <div class="index_year_tit">{{index}}年</div>
        <div class="index_month_box" v-for="(month, indexs) in Object.keys(year).sort()" :key="indexs">
          <div class="index_month_tit"><span v-text="month.replace('-','')+'月'"></span></div>
          <div class="index_day_box">
              <div class="index_day_list" v-for="(day, indexss) in year[month]" :key="indexss">
                  <div class="index_day_list_l">
                      <span class="index_day_list_lt" v-if="day.isfirst">{{day.day}}</span>
                      <span class="index_day_list_lb" v-if="day.isfirst">周{{day.week}}</span>
                  </div>
                  <div class="index_day_list_c">
                      <span v-if="day.doTime.substring(0,10)==toDay">今</span>
                      <var v-if="nextDay.indexOf(day.doTime.substring(0,10))!=-1"></var>
                  </div>
                  <div class="index_day_list_r" :class="'blendent_'+day.type"
                      @click="day.type>1 && goToDetail(day.id)">
                      <span class="index_day_list_rl"><div>{{day.title}}</div></span>
                      <span class="index_day_list_rr"
                          v-if="day.type==3 && (nextDay.indexOf(day.doTime.substring(0,10))!=-1 || day.doTime.substring(0,10)==toDay)">报名</span>
                  </div>
              </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="index_year_box" v-for="(year, index) in listData" :key="index">
        <div class="index_year_tit">{{index}}年</div>
        <div class="index_month_box" v-for="(month, indexs) in year" :key="indexs">
          <div class="index_month_tit"><span v-text="indexs.replace('-','')+'月'"></span></div>
          <div class="index_day_box">
            <div class="index_day_list" v-for="(day, indexss) in month" :key="indexss">
              <div class="index_day_list_l">
                <span class="index_day_list_lt">{{day.day}}</span>
                <span class="index_day_list_lb">周{{day.week}}</span>
              </div>
              <div class="index_day_list_c">
                <span v-if="day.doTime.substring(0,10)==toDay">今</span>
                <var v-if="nextDay.indexOf(day.doTime.substring(0,10))!=-1"></var>
              </div>
              <div class="index_day_list_r" :class="'blendent_'+day.type" @click="day.type>1 && goToDetail(day.id)">
                <span class="index_day_list_rl">{{day.title}}</span>
                <span class="index_day_list_rr" v-if="day.type==3 && (nextDay.indexOf(day.doTime.substring(0,10))!=-1 || day.doTime.substring(0,10)==toDay)">报名</span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
export default {
  name: "",
  components: {
  },
  data() {
    return {
      username: "",
      bannerData:{},
      typeData:{},
      defaultDate:[],
      examDate:{},
    };
  },
  computed: {
     
  },
  mounted() {
   this.getBanner();
  //  this.getType();
  //  this.getMyCalendar();
  //  this.getTopCalendar();
  //  VanDialog.alert({
  //   title: '公告',
  //   messageAlign:'left',
  //   message: '各位亲爱的同学：\n       感谢大家长久以来对《考试历》的支持。\n       《考试历》是专业为全国考生提供研究生考试/专升本、公职类、外语类、计算机类、财经类、职业资格类、医药类、建筑类、企事业招聘、留学等10大类专业考试资讯、报名时间、成绩查询、真题题库等考试服务及最新权威教育资源，是您顺利通过考试的好帮手。\n       自上线以来，它的每一次成长都凝聚着您和工作人员的心血。为了您能更便利的获取考试资讯，我们做了较大的改版。由于数据更新，您之前关注的考试信息均已被取消，给您带来不便之处，敬请谅解。同时为了表达我们的歉意，精心为您准备了额外的补偿，请于2021年8月8日前联系客服领取。\n       我们衷心期待您继续支持和关注《考试历》，也十分感谢您的理解！\n',
  //   }).then(() => {
  //   // on close
  //   });
  },
  
  methods: {
    async monthChanged(){
      return
    },
    async selectDay(data) {
      var selectdata = data[0].toString()+'-'+data[1]+'-'+data[2];
      //console.log(this.defaultDate.indexOf(selectdata));
      if(this.defaultDate.indexOf(selectdata)<0){
        Toast("您选的日期内没有关注的考试哦！");
      }else{
        this.$router.push({ name: 'calendarday', params: { day: selectdata } });
      }
    },
    //获取日历
    async getMyCalendar(){
      const res = await API.getMyCalendar();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.defaultDate = res.data.data;
        //console.log(this.bannerData)
      } else {
        Toast(res.data.message);
      }
    },
    //获取广告图
    async getBanner(){
      const res = await API.getRankList();
      console.log(res)
      // if(res.data.code === 444){
      //   //console.log(res.data.data)
      //   window.location.href = res.data.data
      // }else if (res.data.code === 200) {
      //   this.bannerData = res.data.data.list;
      //   //console.log(this.bannerData)
      // } else {
      //   Toast(res.data.message);
      // }
    },
    //获取行业分类
    async getType(){
      const res = await API.getIndexType();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.typeData = res.data.data;
        //console.log(this.typeData)
      } else {
        Toast(res.data.message);
      }
    },
    //获取考试历推荐列表
    async getTopCalendar(){
      const res = await API.getTopCalendar();
      if(res.data.code === 444){
        //console.log(res.data.data)
        window.location.href = res.data.data
      }else if (res.data.code === 200) {
        this.examDate = res.data.data;
        // console.log(this.examDate)
      } else {
        Toast(res.data.message);
      }
    },
    async gotolink(id){
      //console.log(id)
      this.$router.push({ name: 'typelist', params: { fid: id } });
    },
    async gotoexamlink(id){
      //console.log(id)
      this.$router.push({ name: 'examdetail', params: { id: id } });
    }
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?4c044a9c